/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_SECTION_OPTIONS = gql`
  query GetCostumeTypePartitions(
    $filter: CostumeTypePartitionFilterInput
    $options: GetManyOptions
  ) {
    getCostumeTypePartitions(filter: $filter, options: $options) {
      count
      limit
      skip
      content {
        id
        code
        inventoryDetail {
          defaultInvitesRemaining
          defaultInvitesUsed
          isDefaultSold
          isSectionSpecificSold
          isSpecialReserveSold
          sectionSpecificInvitesRemaining
          sectionSpecificInvitesUsed
          specialInvitesRemaining
          specialInvitesUsed
        }
        section {
          id
          name
        }
        presentation {
          id
          name
        }
        name
        updateHistory {
          date
          _id
          description
          user {
            id
            userId
            lastName
            firstName
            fullName
            email
          }
        }
      }
    }
  }
`;

export const GET_ALL_SECTION_OPTIONS = gql`
  query GetCostumeTypePartitions($filter: CostumeTypePartitionFilterInput) {
    getCostumeTypePartitions(filter: $filter) {
      count
      limit
      skip
      content {
        id
        code
        inventoryDetail {
          defaultInvitesRemaining
          defaultInvitesUsed
          isDefaultSold
          isSectionSpecificSold
          isSpecialReserveSold
          sectionSpecificInvitesRemaining
          sectionSpecificInvitesUsed
          specialInvitesRemaining
          specialInvitesUsed
        }
        section {
          id
          name
        }
        presentation {
          id
          name
        }
        name
      }
    }
  }
`;
